import { FC, PropsWithChildren } from 'react';

interface Props {
  className?: string;
}

const AppDropdownItem: FC<PropsWithChildren<Props>> = ({ children, className }) => {
  return <li className={className}>{children}</li>;
};

export default AppDropdownItem;
